import { LogLevel } from "@azure/msal-browser";


// MSAL 설정
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID, // Azure Portal에서 받은 Application (client) ID
    authority: "https://login.microsoftonline.com/" + process.env.REACT_APP_AZURE_TENANT_ID, // Azure Portal에서 받은 Directory (tenant) ID
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI, // 리디렉션 URI (현재 애플리케이션 URL)
  },
  cache: {
    cacheLocation: "localStorage", // 로그인 상태를 localStorage에 저장
    storeAuthStateInCookie: false, // IE11 또는 Edge를 지원하려면 true로 설정
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// 로그인 요청 시 요청할 권한
export const loginRequest = {
  scopes: ["User.Read"],
};



